'use client';

import { useMutation } from '@apollo/client/react';
import { usePostHog } from 'posthog-js/react';

import type { ReportProblemContext } from '@/shared-ui';
import { REPORT_PROBLEM } from '@/survey-graphql';

import { submitReportProblem } from './survey-project-response-report-problem.helpers';

interface ReportProblemSubmitParams {
  project: { id: string; organization?: { id: string } | null };
  insightId?: string | null;
  responderEmail?: string | null;
}

export function useReportProblemSubmit({
  project,
  insightId,
  responderEmail,
}: ReportProblemSubmitParams) {
  const posthog = usePostHog();

  const [reportProblem] = useMutation(REPORT_PROBLEM);

  return (description: string, context: ReportProblemContext) =>
    submitReportProblem({
      posthog,
      reportProblem: async (input) => {
        await reportProblem({ variables: { input } });
      },
      description,
      context,
      meta: {
        projectId: project.id,
        orgId: project.organization?.id ?? undefined,
        insightId: insightId ?? undefined,
        responderName: responderEmail ?? undefined,
      },
    });
}
